module.exports = __webpack_public_path__ + "static/media/daihatsu-go-drive.6617cd85.jpg";